export const LOGO ="https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";

export const PHOTO_URL = "https://www.shareicon.net/data/256x256/2016/09/01/822711_user_512x512.png";

export const BG_IMAGE = "https://assets.nflxext.com/ffe/siteui/vlv3/7ca5b7c7-20aa-42a8-a278-f801b0d65fa1/fb548c0a-8582-43c5-9fba-cd98bf27452f/IN-en-20240326-popsignuptwoweeks-perspective_alpha_website_large.jpg";

export const API_OPTIONS = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyMzEzODM0NzIwMzU0YjNmMGU0YjZmZmExYjBiMDlhMyIsInN1YiI6IjY1ZjU5YTQ2Yjk3NDQyMDE3ZGZhYjAyZCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.azF7gTg7VmOCYnfSecAh4-mIQ9UqDGdShg6jmzISfi8'
  },
};

export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500";

export const SUPPORTED_LANGUAGES = [
  {identifier:"english", name:"English"},
  {identifier:"hindi", name:"Hindi"},
];